import { render, staticRenderFns } from "./EmailAddressListInput.vue?vue&type=template&id=8b17870e"
import script from "./EmailAddressListInput.vue?vue&type=script&lang=js"
export * from "./EmailAddressListInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports